import { NTMessageTemplate, NTMessageTemplateService } from "@nt-portal/server-sdk";
import { ControllerOptions, DataController } from "../../../types";
import { BaseClientService } from "../base-client.service";


export interface NTMessageTemplateOptions extends ControllerOptions<NTMessageTemplate> {
   
}

export const initializeNTMessageTemplate = () => {
    let tr: NTMessageTemplate = {
        key: "",
        subject: "",
        message: "",
        footer: ""
    }
    return tr;
}


export class ClientNTMessageTemplateService extends BaseClientService implements DataController<NTMessageTemplate> {

    private _service: NTMessageTemplateService;

    constructor() {
        super()
        this._service = new NTMessageTemplateService({
            apiService: this.apiService,
            url: this.settings.fabrixServer
        });
    }
  

    public async get(options: NTMessageTemplateOptions) {
        let fetchParams = this.buildFetchParams(options)
        return await this._service.get(fetchParams, this.token, options.filter);
    }

    public async show() {
        return await this._service.show(this.token)
    }


    public async getById(options: NTMessageTemplateOptions) {
        if (options.id)
            return await this._service.getById(options.id, this.token);
        return null
    }


    public async add(options: NTMessageTemplateOptions) {
        if (options.item)
            return await this._service.add(options.item, this.token);
        return null;
    }

    public async update(options: NTMessageTemplateOptions) {
        if (options.item)
            return await this._service.update(options.item, this.token);
        return null;
    }


    public async delete(options: NTMessageTemplateOptions) {
        if (options.id)
            return await this._service.delete(options.id, this.token);
    }

      public async import(options: NTMessageTemplateOptions): Promise<any> {
        if (options.file)
            return await this._service.importExcel(options.file, this.token);
    }

    public async export(options: NTMessageTemplateOptions): Promise<any> {
        let fetchParams = this.buildLookupFetchParams(options);
        return await this._service.export(this.token, fetchParams, options.filter);
    }

}